import { createContext, useContext, useEffect, useState } from "react";
import { toast } from "sonner";

const InquiryContext = createContext(null);

export const InquiryProvider = ({ children }) => {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("pp-inquiry") || "[]");
    } catch {
      return [];
    }
  });

  useEffect(() => {
    localStorage.setItem("pp-inquiry", JSON.stringify(items));
  }, [items]);

  const addItem = (item) => {
    setItems((prev) => {
      const existing = prev.find((p) => p.product_id === item.product_id);
      if (existing) {
        return prev.map((p) =>
          p.product_id === item.product_id ? { ...p, ...item } : p
        );
      }
      return [...prev, item];
    });
    toast.success(`${item.product_name} added to your inquiry`);
  };

  const removeItem = (product_id) =>
    setItems((prev) => prev.filter((p) => p.product_id !== product_id));

  const updateQuantity = (product_id, quantity) =>
    setItems((prev) =>
      prev.map((p) => (p.product_id === product_id ? { ...p, quantity } : p))
    );

  const clear = () => setItems([]);

  return (
    <InquiryContext.Provider
      value={{ items, addItem, removeItem, updateQuantity, clear, count: items.length }}
    >
      {children}
    </InquiryContext.Provider>
  );
};

export const useInquiry = () => useContext(InquiryContext);
